export default "__VITE_ASSET__DTxK_tgx__"